import React, { createContext, Dispatch, useReducer, useContext } from "react";

import { authReducer } from "./Auth.reducer";
import { AuthState, AuthAction, AuthStateProps } from "./Auth.schema";

const AuthContextState = createContext<AuthStateProps>({} as AuthStateProps);

const AuthContextDispatch = createContext<Dispatch<AuthAction>>(() => null);

const AuthProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, AuthState);
  return (
    <AuthContextState.Provider value={state}>
      <AuthContextDispatch.Provider value={dispatch}>
        {children}
      </AuthContextDispatch.Provider>
    </AuthContextState.Provider>
  );
};

const useAuthDispatchContext = (): React.Dispatch<AuthAction> => {
  const dispatch = useContext(AuthContextDispatch);
  if (dispatch === undefined) {
    throw new Error("state must be used within a Provider");
  }
  return dispatch;
};

const useAuthStateContext = (): AuthStateProps => {
  const state = useContext(AuthContextState);

  if (state === undefined) {
    throw new Error("dispatch must be used within a Provider");
  }
  return state;
};

const useAuth = (): [AuthStateProps, React.Dispatch<AuthAction>] => {
  return [useAuthStateContext(), useAuthDispatchContext()];
};

export { AuthProvider, useAuth };
